const rankings = [
  {
    rank: 1,
    title: '《封神第二部》',
    score: '8.7',
    boxOffice: '38.2亿',
    trend: 'up',
    change: '+2',
    desc: '乌尔善导演神话史诗续作，口碑票房双丰收',
  },
  {
    rank: 2,
    title: '《星际迷航：新纪元》',
    score: '8.4',
    boxOffice: '27.5亿',
    trend: 'down',
    change: '-1',
    desc: '诺兰式实拍震撼视觉，IMAX场次一票难求',
  },
  {
    rank: 3,
    title: '《无名之辈2》',
    score: '8.9',
    boxOffice: '19.8亿',
    trend: 'up',
    change: '+5',
    desc: '黑色幽默续集口碑炸裂，成年度最大黑马',
  },
  {
    rank: 4,
    title: '《长安三万里2》',
    score: '8.6',
    boxOffice: '15.3亿',
    trend: 'same',
    change: '0',
    desc: '追光动画历史系列新作，文化自信之作',
  },
  {
    rank: 5,
    title: '《默杀》',
    score: '7.9',
    boxOffice: '12.6亿',
    trend: 'up',
    change: '+3',
    desc: '社会派悬疑片引发全民讨论，票房持续走高',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="bg-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-[960px] mx-auto">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-fire-line text-2xl text-primary-500"></i>
            </div>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
              热门榜单
            </h2>
          </div>
          <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14">
            综合票房、评分与讨论热度的实时影视排行榜
          </p>

          <div className="space-y-3">
            {rankings.map((item, i) => (
              <div
                key={i}
                className="group flex items-center gap-3 md:gap-5 p-4 md:p-5 bg-background-100 rounded-xl border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
              >
                <div className={`w-9 h-9 md:w-10 md:h-10 flex-shrink-0 flex items-center justify-center rounded-lg font-heading font-bold text-sm md:text-base ${
                  item.rank === 1
                    ? 'bg-accent-500 text-white'
                    : item.rank === 2
                    ? 'bg-secondary-400 text-white'
                    : item.rank === 3
                    ? 'bg-primary-300 text-white'
                    : 'bg-background-200 text-foreground-600'
                }`}>
                  {item.rank}
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 group-hover:text-primary-500 transition-colors truncate">
                      {item.title}
                    </h3>
                    <span className={`flex items-center gap-0.5 text-xs font-semibold whitespace-nowrap ${
                      item.trend === 'up' ? 'text-primary-500' : item.trend === 'down' ? 'text-foreground-400' : 'text-foreground-400'
                    }`}>
                      {item.trend === 'up' && <i className="ri-arrow-up-line text-xs"></i>}
                      {item.trend === 'down' && <i className="ri-arrow-down-line text-xs"></i>}
                      {item.trend === 'same' && <i className="ri-arrow-right-line text-xs"></i>}
                      {item.change}
                    </span>
                  </div>
                  <p className="text-xs text-foreground-500 line-clamp-1">{item.desc}</p>
                </div>

                <div className="flex-shrink-0 text-right">
                  <div className="flex items-center gap-1 text-xs md:text-sm">
                    <i className="ri-star-fill text-accent-500 text-xs"></i>
                    <span className="font-bold text-foreground-800">{item.score}</span>
                  </div>
                  <div className="text-[11px] text-foreground-400 mt-0.5">{item.boxOffice}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}